module.exports = __webpack_public_path__ + "static/media/triangolo1.64e80f26.svg";